<template>
    <v-app>
        <header-component>
            <template v-slot:account_menu>
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-toolbar-title style="color:white" v-bind="attrs" v-on="on" class="userName">
                        {{ user.name }}▼
                        </v-toolbar-title>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in items" :key="index" link :href="item.href">
                            <v-list-item-title>
                                <v-icon> {{ item.icon }}</v-icon>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </header-component>

        <navigation-component>
            <template v-slot:basic>
                <dashboard-navigation-menu-component v-bind:user="user" v-bind:navi="navi" v-bind:path="path"></dashboard-navigation-menu-component>
            </template>
        </navigation-component>

        <!-- アプリケーションのコンポーネントに基づいてコンテンツのサイズを決定 -->
        <v-main app>
            <slot v-bind:navi="navi"></slot>

            <!-- アプリケーションに適切なgutterを提供します -->
            <!--<v-container fluid> -->
            <!-- vue-routerを使用している場合 -->
            <!--</v-container>-->

        </v-main>

        <footer-component>
        </footer-component>
    </v-app>
</template>

<script>
  import {setTimeoutCheckLogin} from '../../common/loginUtil.js';
  export default {
    props: ['user', 'navi', 'path'],
    data: () => ({
        items: [
            { title: 'ダッシュボード', href: '/documents/dashboard', 'icon': 'mdi-home' },
            { title: '管理', href: '/documents/notifications', 'icon': 'mdi-cog' },
            { title: 'ログアウト', href: '/documents/logout', 'icon': 'mdi-logout' },
        ],
    }),
    created () {
        setTimeoutCheckLogin();
    }
};
</script>

<style>
    .userName {
        max-width: 70%;
    }
</style>
